import React, { PureComponent } from 'react';
import uniqid from 'uniqid';
import Button from '@material-ui/core/Button';
import Radio from '@material-ui/core/Radio';
import Select from 'Components/Forms/Elements/Select';
import bemit from 'Functions/bemit';
import { b_seminar_ranges } from 'Shared/options';
export default class BookingRange extends PureComponent {
  state = {
    loading: false,
    ids: {
      start_id: uniqid(),
      end_id: uniqid(),
      render_id: uniqid()
    }
  };
  componentDidUpdate(prev_props, prev_state) {
    const component = this,
      props = this.props,
      state = this.state;
    if (prev_props.availability !== props.availability) {
      component.setState({
        ids: {
          ...state.ids,
          render_id: uniqid()
        }
      });
      props.onChange({
        too_little_seats: hasTooLittleSeats({
          availability: props.availability,
          type: props.type,
          start: props.start ? parseInt(props.start) : undefined,
          end: props.end ? parseInt(props.end) : undefined
        })
      });
    }
  }
  handleRangeChange = ({
    e,
    value,
    name
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    let start = parseInt(name === 'start' ? value : props.start);
    let end = name === 'end' ? parseInt(value) : props.end ? parseInt(props.end) : undefined;
    let update = {};
    if (name === 'start') {
      update.start = value;
      if (end !== undefined && start >= end) {
        update.end = String(start + 1);
      }
    } else if (name === 'end') {
      update.end = value;
      if (end <= start) {
        update.start = String(end - 1);
      }
    }
    update.too_little_seats = hasTooLittleSeats({
      availability: props.availability,
      type: props.type,
      start: parseInt(update.start || start),
      end: parseInt(update.end || end)
    });
    props.onChange(update);
  };
  handleRadioChange = e => {
    const component = this,
      props = this.props,
      state = this.state;
    const {
      value,
      name
    } = e?.target || {};
    component.handleRangeChange({
      name: name,
      value: value
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const {
      ids
    } = state;
    const modifiers = [].concat(props.bemit || []);
    const availability = (props.availability || []).slice(0);
    const half_day_layout = ['b_seminar', 'c_open_coworking_space'].includes(props.type);
    let start_options = availability.filter(function (infos) {
      if (!half_day_layout && infos.delta_expired) return false;

      // if (half_day_layout)
      // {
      // 	return infos.available === true;
      // }

      return infos.start ? true : false;
    }).map(function (infos) {
      let value, label;
      if (half_day_layout) {
        const config = b_seminar_ranges.find(config => config.value === infos.start);
        value = config.value;
        label = config.label;
      } else {
        value = infos.start;
        label = infos.start ? infos.start + 'h' : infos.start;
      }
      return {
        value: value,
        label: label
      };
    });
    if (half_day_layout && availability.every(i => i.available)) {
      const config = b_seminar_ranges.find(config => config.value === 'day');
      start_options.push({
        value: 'day',
        label: config.label
      });
    }
    const end_options = (availability || []).filter(function (infos) {
      if (infos.delta_expired) return false;
      return !infos.end ? false : true;
    }).map(function (infos) {
      return {
        value: infos.end,
        label: infos.end + 'h'
      };
    });
    let start_input;
    if (half_day_layout) {
      if (props.type === 'c_open_coworking_space') {
        start_options = start_options.filter(config => config.value !== 'day');
      }
      const radios = start_options.map(function (config) {
        let availability_item = config.value === 'day' ? undefined : availability.find(data => data.start === config.value);
        let delta_expired = availability_item ? availability_item.delta_expired : false;
        let hours_range = availability_item && availability_item.hours_range ? availability_item.hours_range || undefined : undefined;
        if (config.value === 'day') {
          delta_expired = availability.some(data => data.delta_expired);
          let morning_infos = availability.find(data => data.start === 'morning');
          let afternoob_infos = availability.find(data => data.start === 'afternoon');
          if (morning_infos && morning_infos.hours_range) {
            hours_range = morning_infos.hours_range;
          }
          if (afternoob_infos && afternoob_infos.hours_range) {
            if (hours_range) hours_range += ' et ';
            hours_range = hours_range || '';
            hours_range += afternoob_infos.hours_range;
          }
        }
        const is__disabled = delta_expired || availability_item && availability_item.available !== true;
        const output = /*#__PURE__*/React.createElement("div", {
          className: "c-booking-range__radio-container",
          key: config.value
        }, /*#__PURE__*/React.createElement(Button, {
          htmlFor: ids.start_id + config.value,
          component: "label",
          disabled: is__disabled,
          className: 'c-booking-range__label' + (delta_expired ? ' is-expired' : is__disabled ? ' is-disabled' : '')
        }, /*#__PURE__*/React.createElement(Radio, {
          checked: props.start === config.value,
          className: "c-booking-range__radio",
          onChange: component.handleRadioChange,
          value: config.value,
          name: "start",
          id: ids.start_id + config.value,
          disabled: is__disabled
        }), config.label, delta_expired ? ' (Expiré)' : is__disabled ? ' (Réservé)' : hours_range ? ' (' + hours_range + ')' : undefined));
        return output;
      });
      start_input = radios.length > 0 ? /*#__PURE__*/React.createElement("div", {
        className: "c-booking-range__b_seminar-range"
      }, radios) : undefined;
    } else {
      start_input = /*#__PURE__*/React.createElement(Select, {
        className: "c-booking-range__select",
        name: "start",
        id: ids.start_id,
        key: ids.render_id,
        onChange: component.handleRangeChange,
        value: props.start,
        options: start_options,
        status: props.status_messages,
        "full-width": false
      });
    }
    const output = /*#__PURE__*/React.createElement("div", {
      className: bemit('c-booking-range', modifiers)
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-booking-range__content"
    }, start_input ? /*#__PURE__*/React.createElement("div", {
      className: "c-booking-range__element"
    }, /*#__PURE__*/React.createElement("label", {
      htmlFor: ids.start_id,
      className: "c-booking-range__label"
    }, half_day_layout ? 'Créneau' : 'Début'), start_input) : undefined, !half_day_layout ? /*#__PURE__*/React.createElement("div", {
      className: "c-booking-range__element"
    }, /*#__PURE__*/React.createElement("label", {
      htmlFor: ids.end_id,
      className: "c-booking-range__label"
    }, "Fin"), /*#__PURE__*/React.createElement(Select, {
      className: 'c-booking-range__select' + (!props.start ? ' disabled' : ''),
      name: "end",
      id: ids.end_id,
      key: ids.render_id,
      onChange: component.handleRangeChange,
      value: props.end,
      options: end_options,
      status: props.status_messages,
      "full-width": false,
      "read-only": !props.start
    })) : undefined));
    return output;
  }
}
function hasTooLittleSeats({
  availability = [],
  type,
  start,
  end
}) {
  const has_dates = start && end;
  if (!has_dates || ['b_seminar', 'c_open_coworking_space'].includes(type)) {
    return false;
  }
  let too_little_seats = false;
  too_little_seats = availability.filter(function (infos) {
    // Range begin before start
    if (parseInt(infos.start) < start) {
      return false;
    }
    return parseInt(infos.start) < end;
  }).some(function (infos) {
    if (infos.too_little_seats === true) return true;
    return parseInt(infos.remaining_seats || '0') > 0 === false;
  });
  return too_little_seats;
}
